"use client";

import type { ComponentType, FC } from "react";

import dynamic from "next/dynamic";

import type { AccordionSlidesLazyAssetProps, NormalizedAsset } from "./AccordionSlidesShared";

const AccordionSlidesAssetVideo = dynamic<AccordionSlidesLazyAssetProps>(() =>
  import("./AccordionSlidesAssetVideo").then(mod => mod.AccordionSlidesAssetVideo),
);
const AccordionSlidesAssetChatScenario = dynamic<AccordionSlidesLazyAssetProps>(() =>
  import("./AccordionSlidesAssetChatScenario").then(
    mod => mod.AccordionSlidesAssetChatScenario as ComponentType<AccordionSlidesLazyAssetProps>,
  ),
);
const AccordionSlidesAssetImage = dynamic<AccordionSlidesLazyAssetProps>(() =>
  import("./AccordionSlidesAssetImage").then(mod => mod.AccordionSlidesAssetImage),
);
const components = {
  video: AccordionSlidesAssetVideo,
  chatScenario: AccordionSlidesAssetChatScenario,
  backgroundForegroundImage: AccordionSlidesAssetImage,
} satisfies Record<NormalizedAsset["type"], ComponentType<AccordionSlidesLazyAssetProps>>;

type AccordionSlidesAssetProps<Name extends keyof typeof components> = {
  name: Name;
} & React.ComponentProps<(typeof components)[Name]>;

export const AccordionSlidesAsset = <Name extends keyof typeof components>({
  name,
  ...props
}: AccordionSlidesAssetProps<Name>) => {
  const Component = components[name] as FC<AccordionSlidesLazyAssetProps>;

  return <Component {...props} />;
};
